module.exports = __webpack_public_path__ + "client/styles/fonts/SourceSansPro-Black.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/styles/fonts/SourceSansPro-Black.ttf
// module id = 1486
// module chunks = 0